export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#38bd5a',
      '#3041a6',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  fsCount: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: ['#31d9ef'],
    strokeThickness: 2,
    fontFamily: 'Dimbo Regular',
    fontSize: 70,
    fontWeight: 'bolder',
  },
}
